import { useEffect, useRef, useState } from 'react';

const sharedKey = (code: string) => 'zeroth-partner-link-copied:' + code;

/** Whether this browser has copied the partner's link; drives the getting-started checklist. */
export function hasCopiedLink(code: string): boolean {
  try {
    return window.localStorage.getItem(sharedKey(code)) === '1';
  } catch {
    return false;
  }
}

export function useCopy(code?: string) {
  const [copied, setCopied] = useState(false);
  const [failed, setFailed] = useState(false);
  const timer = useRef<number>();
  useEffect(() => () => window.clearTimeout(timer.current), []);
  async function copy(text: string) {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setFailed(false);
      if (code) {
        try {
          window.localStorage.setItem(sharedKey(code), '1');
        } catch {
          // The checklist simply stays unchecked without storage.
        }
      }
      window.clearTimeout(timer.current);
      timer.current = window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setFailed(true);
    }
  }
  return { copy, copied, failed };
}
